import { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Grid,
  Card,
  CardContent,
  Box,
  Tooltip,
  IconButton,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  Autocomplete,
  Checkbox,
  Switch,
} from "@mui/material";
import { uploadTemplateApi } from "../../app/slices/templateCreation/uploadTemplateSlice";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import { getAllTemplateApi } from "../../app/slices/templateCreation/getAllTemplateSlice";
import { ContentCopy, Delete as DeleteIcon } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import { deleteTemplateApi } from "../../app/slices/templateCreation/deleteTemplateSlice";
import { FormHelperText } from "@mui/material";
import { updateTemplateApi } from "../../app/slices/templateCreation/updateTemplateSlice";
import axios from "axios";
import { toast } from "react-toastify";
import axiosInstance from "../../utils/axiosInstance";
import { useFileTypeValidator } from "../../utils/fileTypeValidator";

export default function TemplateCreation() {
  const baseUrl = import.meta.env.VITE_BASE_URL;
  const token = localStorage.getItem("token");

  const dispatch = useDispatch();
  const roleResponse = useSelector((state) => state.login.login.role);

  useEffect(() => {
    dispatch(getAllTemplateApi());
  }, [dispatch]);

  const sliceResponse = useSelector(
    (state) => state.getAllTemplate.getAllTemplate.data,
  );
  const stateLoading = useSelector((state) => state.getAllTemplate.loading);

  const [formData, setFormData] = useState({
    template_image: null,
    title: "",
    description: "",
    colorCode: "#ffffff", // Default color
    region: [],
  });
  const maxSize = 5 * 1024 * 1024;
  const allowedExtensions = ["png", "jpg"];
  const { validatedFile, error: fileError } = useFileTypeValidator(
    formData.template_image,
    allowedExtensions,
    maxSize,
  );
  // console.log("formData: ", formData);

  const [errors, setErrors] = useState({
    template_image: false,
    title: false,
    description: false,
    region: false,
  });

  const validateForm = () => {
    const newErrors = {
      template_image: !formData.template_image,
      title: formData.title.trim() === "",
      description: formData.description.trim() === "",
      region: formData.region.length === 0,
      // region: !formData.region,
    };
    setErrors(newErrors);
    return !Object.values(newErrors).includes(true);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({ ...prev, [name]: false }));
  };

  // const handleFileChange = (event) => {
  //     setFormData((prev) => ({ ...prev, template_image: event.target.files[0] }));
  //     setErrors((prev) => ({ ...prev, template_image: false }));
  // };

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    setFormData((prev) => ({
      ...prev,
      template_image: file,
    }));

    setErrors((prev) => ({ ...prev, template_image: false }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (fileError) {
      toast.error(fileError);
      return;
    }
    if (validateForm()) {
      try {
        const response = await dispatch(uploadTemplateApi(formData));
        if (response.meta.requestStatus === "fulfilled") {
          Swal.fire({
            text: "Upload Successful!",
            icon: "success",
            timer: 3000,
            showConfirmButton: false,
          });
          dispatch(getAllTemplateApi());

          // Reset formData after successful submission
          setFormData({
            template_image: null,
            title: "",
            description: "",
            colorCode: "#ffffff",
            region: "",
          });

          // Manually reset the file input field to clear the file name
          document.getElementById("file-input").value = ""; // This clears the input field
        }
      } catch (error) {
        console.log("error: ", error);
      }
    }
  };
  //    ***************************************************** Edit ********************************************
  const [editState, seteditState] = useState(false);

  const handleUpdate = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      try {
        const response = await dispatch(updateTemplateApi(formData));
        if (response.meta.requestStatus === "fulfilled") {
          Swal.fire({
            text: "Updated Successfully!",
            icon: "success",
            timer: 3000,
            showConfirmButton: false,
          });
          dispatch(getAllTemplateApi());
          // Reset formData after successful submission
          setFormData({
            template_image: null,
            title: "",
            description: "",
            colorCode: "#ffffff",
            region: "",
          });
          seteditState(false);
          // Manually reset the file input field to clear the file name
          document.getElementById("file-input").value = ""; // This clears the input field
        }
      } catch (error) {
        console.log("error: ", error);
      }
    }
  };

  const handleStatusChange = async (id) => {
    try {
      const url = `/templateToggle/${id}`;
      // const url = `${baseUrl}/templateToggle/${id}`;
      const response = await axiosInstance.put(
        url,
        {},
        //     {
        //     headers: {
        //         "Content-Type": "application/json",
        //         Accept: "application/json",
        //         Authorization: `Bearer ${token}`,
        //     },
        // }
      );
      // const response = await axios.put(url, {}, {
      //     headers: {
      //         "Content-Type": "application/json",
      //         Accept: "application/json",
      //         Authorization: `Bearer ${token}`,
      //     },
      // });
      if (response.data.error == false) {
        Swal.fire({
          text: "Status Updated Successfully!",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        });
        // toast.success(response.data.message);
        dispatch(getAllTemplateApi());
      } else {
        Swal.fire({
          text: "Failed to update status",
          icon: "error",
          timer: 2000,
          showConfirmButton: false,
        });
        // toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error updating status:", error);
      Swal.fire({
        text: "Failed to update status",
        icon: "error",
        timer: 2000,
        showConfirmButton: false,
      });
      //   toast.error("Failed to update status");
    }
  };

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("title", {
      header: "Title",
      size: 30,
    }),
    columnHelper.accessor("description", {
      header: "Description",
      size: 30,
    }),

    columnHelper.accessor("region", {
      header: "Region",
      size: 30,
      Cell: ({ row }) => {
        const regions = row.original.region;

        // Agar regions array hai toh capitalize karke join kar denge
        if (Array.isArray(regions)) {
          return regions
            .map((region) => region.charAt(0).toUpperCase() + region.slice(1))
            .join(", ");
        }

        // Agar single string hai toh sirf capitalize karenge
        return regions
          ? regions.charAt(0).toUpperCase() + regions.slice(1)
          : "-";
      },
    }),
    // columnHelper.accessor("region", {
    //     header: "Region",
    //     size: 30,
    // }),

    columnHelper.accessor("url", {
      header: "Image",
      size: 30,
      Cell: ({ cell }) => (
        <img
          src={cell.getValue()}
          alt="Image"
          style={{ width: "50px", height: "50px", objectFit: "cover" }}
        />
      ),
    }),

    columnHelper.accessor("colorCode", {
      header: "colorCode",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.colorCode);
          toast.success("Copied to clipboard!");
        };
        return (
          <Box display="flex" alignItems="center" gap={1}>
            <Tooltip title={cell.row.original?.colorCode}>
              <IconButton onClick={handleCopy} size="small">
                <ContentCopy />
              </IconButton>
            </Tooltip>
            <div
              style={{
                backgroundColor: cell.getValue(),
                width: "100%",
                height: "30px",
                border: "1px solid #ccc",
                borderRadius: "4px",
              }}
            />
          </Box>
        );
      },
    }),

    // columnHelper.accessor("colorCode", {
    //     header: "colorCode",
    //     size: 300,
    //     Cell: ({ cell }) => {
    //         const handleCopy = () => {
    //             navigator.clipboard.writeText(cell.row.original?.colorCode);
    //             toast.success("Copied to clipboard!");
    //         };
    //         return (
    //             <>
    //                 <Tooltip title={cell.row.original?.colorCode}>
    //                     <IconButton onClick={handleCopy}>
    //                         <ContentCopy />
    //                     </IconButton>
    //                 </Tooltip>
    //                 <span
    //                     style={{
    //                         width:"100%",
    //                         backgroundColor: cell.getValue(),
    //                         padding: "5px",
    //                         color: "#000",
    //                     }}
    //                 ></span>
    //             </>
    //         );
    //     },
    // }),
    // columnHelper.accessor("colorCode", {
    //     header: "Color",
    //     Cell: ({ cell }) => (
    //         <>
    //             <div>

    //                 {cell.getValue()}
    //             </div>
    //             <div
    //                 style={{
    //                     backgroundColor: cell.getValue(),
    //                     padding: "5px",
    //                     color: "#000",
    //                 }}
    //             >
    //             </div>

    //         </>
    //     ),
    // }),
    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: (cell) => (
        <span style={{ textAlign: "center" }}>
          {cell.row.original.createdAt.split("T")[0]}
        </span>
      ),
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 30,
      Cell: (cell) => (
        <span style={{ textAlign: "center" }}>
          {cell.row.original.updatedAt.split("T")[0]}
        </span>
      ),
    }),
    columnHelper.accessor("status", {
      header: "Status",
      size: 30,
      Cell: ({ cell }) => {
        const isActive = cell.getValue() == 1 ? true : false;
        const rowId = cell.row.original._id;
        const handleToggle = () => {
          handleStatusChange(rowId);
        };
        return (
          <Switch
            checked={isActive} // checked when inactive (1)
            onChange={handleToggle}
            inputProps={{ "aria-label": "Status toggle" }}
          />
        );
      },
    }),
  ];

  if (
    roleResponse?.TemplateCreation?.update === 1 ||
    roleResponse?.TemplateCreation?.delete === 1
  ) {
    columns.push(
      columnHelper.accessor("Actions", {
        header: "Actions",
        size: 30,
        Cell: ({ cell }) => {
          const rowId = cell.row.original._id;
          const rowData = cell.row.original;

          return (
            <Box>
              {roleResponse?.TemplateCreation?.update === 1 && (
                <Tooltip title="Edit">
                  <IconButton
                    onClick={() => {
                      seteditState(true);
                      setFormData({
                        _id: rowId,
                        template_image: null,
                        title: rowData?.title || "",
                        description: rowData?.description || "",
                        colorCode: rowData?.colorCode || "#ffffff",
                        region: rowData?.region || "",
                      });
                      document.getElementById("file-input").value = ""; // This clears the input field

                      window.scrollTo({
                        top: 0,
                        behavior: "smooth", // for smooth scrolling
                      });
                    }}
                  >
                    <EditIcon color="error" />
                  </IconButton>
                </Tooltip>
              )}
              {roleResponse?.TemplateCreation?.delete === 1 && (
                <Tooltip title="Delete">
                  <IconButton
                    onClick={async () => {
                      const result = await Swal.fire({
                        title: "Are you sure ?",
                        text: "You will not be able to recover this post!",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#4a2a7d",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Yes, delete it!",
                      });
                      if (result.isConfirmed) {
                        dispatch(deleteTemplateApi({ rowId }));
                        dispatch(getAllTemplateApi());
                        Swal.fire({
                          text: "Deleted Successful!",
                          icon: "success",
                          timer: 3000,
                          showConfirmButton: false,
                        });
                      }
                    }}
                  >
                    <DeleteIcon color="red" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          );
        },
      }),
    );
  }

  const dataForRegionSelection = [
    { name: "Select All" },
    { name: "north" },
    { name: "west" },
    { name: "south" },
    { name: "east" },
    // { name: "central" },
  ];
  const allRegions = dataForRegionSelection.slice(1).map((r) => r.name); // skip "Select All"

  // If "Select All" is clicked → select/deselect all
  const handleRegionChange = (event, selectedValues) => {
    if (selectedValues.some((item) => item.name === "Select All")) {
      if (formData.region.length === allRegions.length) {
        // Deselect all
        setFormData({ ...formData, region: [] });
      } else {
        // Select all except "Select All"
        setFormData({ ...formData, region: allRegions });
      }
    } else {
      // Normal selection
      setFormData({
        ...formData,
        region: selectedValues.map((r) => r.name),
      });
    }
  };

  return (
    <>
      {roleResponse?.TemplateCreation?.write === 1 && (
        <Card sx={{ mb: 4 }}>
          <CardContent>
            <Grid container spacing={3} justifyContent="center">
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  label="Title"
                  variant="outlined"
                  fullWidth
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  error={errors.title}
                  helperText={errors.title ? "Title is required" : ""}
                />
              </Grid>
              <Grid item xs={12} lg={6} md={6}>
                <TextField
                  fullWidth
                  type="file"
                  id="file-input" // Added id to the input for easy reference
                  name="template_image"
                  onChange={handleFileChange}
                  error={errors.template_image}
                  helperText={errors.template_image ? "Image is required" : ""}
                  // helperText={
                  //     errors.template_image
                  //         ? "Image is required"
                  //         : fileError
                  //             ? fileError
                  //             : ""
                  // }
                />

                {fileError ? (
                  <FormHelperText error>{fileError}</FormHelperText>
                ) : (
                  <FormHelperText>
                    Allowed file type{" "}
                    {allowedExtensions.map((format) => `.${format}`).join(", ")}{" "}
                    with max size {maxSize / (1024 * 1024)} MB
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <TextField
                  label="Description"
                  variant="outlined"
                  // size="small"
                  fullWidth
                  multiline
                  rows={2}
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  error={errors.description}
                  helperText={
                    errors.description ? "Description is required" : ""
                  }
                />
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <TextField
                  fullWidth
                  type="color"
                  label="Select Color"
                  name="colorCode"
                  value={formData.colorCode}
                  onChange={handleChange}
                  sx={{ height: "100%" }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <Autocomplete
                  multiple
                  id="Region"
                  name="region"
                  options={dataForRegionSelection}
                  value={dataForRegionSelection.filter((r) =>
                    formData.region?.includes(r.name),
                  )}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option.name}
                  isOptionEqualToValue={(option, value) =>
                    option.name === value.name
                  }
                  onChange={handleRegionChange}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        style={{ marginRight: 8 }}
                        checked={
                          option.name === "Select All"
                            ? formData.region?.length ===
                              dataForRegionSelection.length - 1
                            : selected
                        }
                      />
                      {option.name}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Region" // ✅ Added label
                      variant="outlined"
                      sx={{
                        width: "100%",
                        ".MuiAutocomplete-input": {
                          border: "none",
                        },
                      }}
                      error={errors.region} // ✅ Corrected binding
                      helperText={errors.region ? "Region is required" : ""} // ✅ Corrected binding
                    />
                  )}
                />
              </Grid>

              {/* <Grid item xs={12} md={3}>
                                <Autocomplete
                                    multiple
                                    id="Region"
                                    name="region"
                                    options={dataForRegionSelection}
                                    value={dataForRegionSelection.filter((r) =>
                                        formData.region?.includes(r.name)
                                    )}
                                    disableCloseOnSelect
                                    getOptionLabel={(option) => option.name}
                                    isOptionEqualToValue={(option, value) => option.name === value.name}
                                    onChange={handleRegionChange}
                                    renderOption={(props, option, { selected }) => (
                                        <li {...props}>
                                            <Checkbox
                                                style={{ marginRight: 8 }}
                                                checked={
                                                    option.name === "Select All"
                                                        ? formData.region?.length ===
                                                        dataForRegionSelection.length - 1
                                                        : selected
                                                }
                                            />
                                            {option.name}
                                        </li>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            sx={{
                                                width: "100%",
                                                ".MuiAutocomplete-input": {
                                                    // height: "6px",
                                                    border: "none",
                                                },
                                            }}
                                            error={errors.region}
                                            helperText={errors.region ? "Regions is required" : ""}
                                   
                                        />
                                    )}
                                />
                            </Grid> */}

              {!editState && (
                <Grid item xs={12} sm={12} md={6} lg={6} textAlign="center">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    sx={{
                      p: { xs: 1, sm: 1.8, md: 1.8 },
                      width: {
                        xs: "100%",
                        sm: "100%",
                        md: "100%",
                        lg: "100%",
                        xl: "100%",
                      },
                      transition: "transform 0.5s ease-in-out",
                      "&:hover": {
                        transform: "scale(1.01)", // Increase size on hover
                        // boxShadow: "1px 2px 3px 4px yellow", // Add shadow on hover
                      },
                    }}
                  >
                    Submit
                  </Button>
                </Grid>
              )}
              {editState && (
                <>
                  <Grid item xs={6} sm={6} md={3} lg={3} textAlign="center">
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleUpdate}
                      sx={{
                        p: { xs: 1, sm: 1.8, md: 1.8 },
                        width: {
                          xs: "100%",
                          sm: "100%",
                          md: "100%",
                          lg: "100%",
                          xl: "100%",
                        },
                        transition: "transform 0.5s ease-in-out",
                        "&:hover": {
                          transform: "scale(1.05)", // Increase size on hover
                          // boxShadow: "1px 2px 3px 4px yellow", // Add shadow on hover
                        },
                      }}
                    >
                      Update
                    </Button>
                  </Grid>
                  <Grid item xs={6} sm={6} md={3} lg={3} textAlign="center">
                    <Button
                      variant="contained"
                      // color="primary"
                      onClick={() => {
                        seteditState(false);
                        setFormData({
                          template_image: null,
                          title: "",
                          description: "",
                          colorCode: "#ffffff",
                          region: "",
                        });
                        document.getElementById("file-input").value = ""; // This clears the input field
                      }}
                      sx={{
                        backgroundColor: "#bc2020 !important", // Green color
                        p: { xs: 1, sm: 1.8, md: 1.8 },
                        width: {
                          xs: "100%",
                          sm: "100%",
                          md: "100%",
                          lg: "100%",
                          xl: "100%",
                        },
                        transition: "transform 0.5s ease-in-out",
                        "&:hover": {
                          transform: "scale(1.05)", // Increase size on hover
                          // boxShadow: "1px 2px 3px 4px yellow", // Add shadow on hover
                          backgroundColor: "#ca2727", // Darker green on hover
                        },
                      }}
                    >
                      Cancel
                    </Button>
                  </Grid>
                </>
              )}
            </Grid>
          </CardContent>
        </Card>
      )}

      <CustomTable
        columns={columns}
        data={sliceResponse}
        loading={stateLoading}
        permissionKey="TemplateCreation"
      />
    </>
  );
}
